import * as React from "react";
const SvgFavorite24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 23,
        fill: "black",
        viewBox: "0 0 24 23"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m12 .84 3.695 7.074 7.87 1.329-5.586 5.7 1.168 7.895L12 19.287l-7.147 3.55 1.168-7.894-5.586-5.7 7.87-1.329L12 .84Zm0 4.32L9.617 9.72l-5.074.857 3.602 3.676-.753 5.09L12 17.053l4.608 2.29-.753-5.09 3.601-3.676-5.073-.856L12 5.16Z",
      clipRule: "evenodd"
    })
  );
export default SvgFavorite24Px;
